import React from 'react';
import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { RootState, useAppDispatch, useAppSelector } from "../../../state/state.tsx";
import { closeModal, toggleLoading } from "../../../state/ModalSlice/ModalSlice.ts";
import LiveSubProfilePic from "../../../assets/subscriptions/ProfilePhoto2Update.png";
import { CircularProgress, IconButton } from "@mui/material";
import { useBackend } from "../../../hooks/backend/useBackend.ts";
import { toast } from "react-toastify";
import { SECRETS_ENV } from "../../../Config/firebase.ts";
import CloseIcon from "@mui/icons-material/Close";
import { selectEffectiveUID } from '../../../state/UserStatesV2/userSliceV2.ts';
import { Timestamp } from 'firebase/firestore';
import { logAction } from '../utilityFunctions.ts';
import { ActionType } from '../../../enums.ts';


export default function TerminateLiveSubscription() {

    const Dispatch = useAppDispatch();
    const ServiceProviderID = useAppSelector(selectEffectiveUID) 
    const open = useAppSelector((state: RootState) => state.ModalSlice.TerminateLiveSubscriptionModalOpen);
    const { uid: spId, display_name: spName } = useAppSelector((state: RootState) => state.userSliceV2?.data) || {}
    
    // Subs and LiveSubs Docs

    const {
        LiveSubscriptionId
    } = useAppSelector((state: RootState) => state.ArbitrarySlice.ForTerminateLiveSubscriptionModal)


    const AllLiveSubcriptionDocs = useAppSelector((state: RootState) => state.LiveSubscriptionSlice.data)
    const selectedLiveSubscriptionDoc = AllLiveSubcriptionDocs?.filter((doc) => doc.id === LiveSubscriptionId)[0] || null;

    const isLoading = useAppSelector((state: RootState) => state.ModalSlice.isLoading)

    // Component States

    const [SettlementAmount, setSettlementAmount] = React.useState<string>("0");
    const [modalError, setModalError] = React.useState({
        SettlementAmount: false,
    });
    const [, setIsError] = useState<boolean>(false);

    // Handle onChange

    const handleChangeSettlementAmount = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        // Function to handle decimal, number, and negative inputs

        if (!value) {
            setSettlementAmount("");
            return;
        }

        const regex = /^-?\d*\.?\d*$/;
        if (regex.test(value)) {
            setSettlementAmount(value);
        }
    }


    // Error check
    function CheckErrors(): boolean {
        setIsError(false)
        let localerror: boolean = false


        if (!SettlementAmount || SettlementAmount.trim() === "") {
            localerror = true
            setIsError(true)
            setModalError((prev) => {
                return { ...prev, SettlementAmount: true }
            })
        } else {

            setModalError((prev) => {
                return { ...prev, SettlementAmount: false }
            })
        }
        return localerror

    }

    // OnSubmit function

    const { axiosPostRequest } = useBackend("")

    async function handleAPICall() {
        Dispatch(toggleLoading(true))
        const body = {
            providerId: ServiceProviderID,
            livesubscriptionId: LiveSubscriptionId,
            samount: Number(SettlementAmount),
            effectiveDate: new Date().getTime()

        }
        try {
            const response = await axiosPostRequest(`${SECRETS_ENV.API_END_POINT}/api/terminate`, body)
            if (response.message !== "Request successful") {

                Dispatch(toggleLoading(false))
                return "error"
            }
        } catch (error) {

            Dispatch(toggleLoading(false))
            return "error"
        }

        logAction({
            action: ActionType.terminateLiveSubscription,
            timestamp: Timestamp.now(),
            platform: "web",
            performedBy: {
                spId: spId || "",
                name: spName || ""
            },
            context: {
                liveSubscriptionId: LiveSubscriptionId,
            },
        }, ServiceProviderID)
        Dispatch(toggleLoading(false))
        return "success"

    }


    async function onSubmit(e: any) {
        e.preventDefault()
        const Localerrors = CheckErrors()

        if (Localerrors) {
            return
        }
        const apiSuccess = await handleAPICall()
        if (apiSuccess === "error") {
            toast.error("Error terminating Subscriber")
        } else {
            toast.success("Subscriber Terminated Successfully")
        }
        handleClose()
    }

    // Modal handlers

    function handleClose() {

        Dispatch(closeModal("TerminateLiveSubscriptionModalOpen"))
        setSettlementAmount("0")
    }

    return (<React.Fragment>

        <Dialog
            sx={{
                padding: 0,
                '& .MuiPaper-root': {
                    borderRadius: '16px',
                },
            }}
            maxWidth="md"
            open={open}

            PaperProps={{
                component: 'div',
            }}
        >

            <div className={"absolute right-4 top-4"}><IconButton onClick={handleClose}>
                <CloseIcon />
            </IconButton></div>

            <DialogContent sx={{ paddingY: "50px", paddingX: "60px" }} className={"bg-white"}>
                <div className={"header pb-[20px] min-w-[550px]"}>
                    <p className={"text-cf_heading font-[600] "}>Terminate Subscription</p>
                    <p className={"text-cf_small font-[400] "}>Are you
                        sure {selectedLiveSubscriptionDoc?.studentName} is planning to end
                        subscription?</p>
                </div>

                <div className={"pt-0 flex items-center gap-2"}>

                    <div className={" p-1 bg-white rounded-full border-solid border-gray-400 border-2 flex"}>
                        <img
                            className="inline-block size-20 rounded-full ring-2 ring-white cursor-pointer"
                            src={LiveSubProfilePic} // Make sure profilePhoto is defined
                            alt="Profile"

                        />
                    </div>
                    <div>
                        <p>Payee : {selectedLiveSubscriptionDoc?.studentName}</p>
                        <p>Frequency : {selectedLiveSubscriptionDoc?.cycle}</p>
                    </div>


                </div>

                <div className={"max-w-[550px] text-sm text-cc_error mt-6 pl-1"}>

                    Subscriber will be terminated with immediate effect from today,Please ensure that all pending payments are settled externally once the subscriber has been terminated.

                </div>

                <div className={"w-[550px] flex  mt-4"}>
                    <p>Advance / Registration Fee Received: Rs. {selectedLiveSubscriptionDoc?.advance}</p>
                    <p></p>
                </div>

                <div className={"flex gap-2 pt-8"}>
                    <button disabled={isLoading} onClick={(e) => {
                        e.preventDefault();
                        handleClose()
                    }}
                        className={`w-full bg-cc_bg-tertiary border border-solid border-gray-500 p-1.5 rounded-lg ${isLoading ? "cursor-not-allowed" : ""} `}>Cancel
                    </button>
                    <button disabled={isLoading}
                        onClick={onSubmit}
                        className={`w-full bg-cc_brand text-white p-1.5 rounded-lg border-gray-500 flex justify-center items-center ${isLoading ? "cursor-not-allowed" : ""}`}>{isLoading &&
                            <CircularProgress sx={{ color: "white" }} size={20} />}
                        <p className={"ml-2"}>{isLoading ? "Loading" : "Confirm"}</p>
                    </button>

                </div>

            </DialogContent>

        </Dialog>

    </React.Fragment>);
}